import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { dashboardDetails, deleteUser } from "../../../store/actions";
import moment from "moment";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
} from "../../../Common/DataTable";
import DashboardRevenueGraph from "./DashboardRevenueGraph";
import DashboardStatusGraph from "./DashboardStatusGraph";

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "name",
    align: false,
    disablePadding: true,
    label: "Name",
    title: "Name",
    order: 1,
  },
  {
    id: "email",
    align: true,
    disablePadding: false,
    label: "Email",
    title: "Email",
    order: 1,
  },
  {
    id: "mobileNumber",
    numeric: false,
    disablePadding: false,
    label: "Mobile Number",
    title: "Mobile",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    title: "Mobile",
    type: "tag",
  },
  {
    id: "createdAt",
    align: true,
    disablePadding: false,
    label: "Register At	",
    type: "date",
    title: "Date|Time",
    order: 1,
  },
  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];

const DashboardIndex = () => {
  const dispatch = useDispatch();
  const [deleteShow, deleteSetShow] = useState(false);
  const deleteClose = () => deleteSetShow(false);
  const deleteShowPop = () => deleteSetShow(true);

  const [Delete, setDelete] = useState({
    open: false,
    dumpId: "",
  });

  const [dates, setDates] = useState({
    startDate: moment().startOf("week").format("YYYY-MM-DD"),
    endDate: moment().endOf("week").format("YYYY-MM-DD"),
  });

  const [graphData, SetGraphData] = useState({
    revenue: [],
    status: [],
    adminCommission: [],
  });

  var start = moment(dates.startDate);
  var end = moment(dates.endDate);
  const list = [];
  for (var current = start; current <= end; current.add(1, "d")) {
    list.push(current.format("MMMM DD"));
  }

  const DashboardData = useSelector((s) => s.Dashboard.dashboardDetails?.data);
  const loading = useSelector((s) => s?.Dashboard?.loading);

  const [state, setState] = useState({
    totalBookingsCount: 0,
    totalUser: 0,
    totalProviders: 0,
    totalCompletedBookings: 0,
    upcomingBookings: 0,
    totalRevenue: 0,
    totalRevenueMonthly: [],
    latestUsers: [],
    requestedBookingsCount: 0,
    rejectedBookingsCount: 0,
    acceptedBookingsCount: 0,
    cancelledBookingsCount: 0,
    completedBookingsCount: 0,
    inProgressBookingsCount: 0,
    inRouteBookingsCount: 0,
  });

  useEffect(() => {
    dispatch(dashboardDetails());
  }, []);

  useEffect(() => {
    if (DashboardData !== undefined) {
      setState((pre) => ({
        ...pre,
        latestUsers: DashboardData?.latestUsers,
        totalBookingsCount: DashboardData?.totalBookingsCount,
        totalUser: DashboardData?.totalUser,
        totalProviders: DashboardData?.totalProviders,
        totalRevenue: DashboardData?.totalRevenue,
        totalRevenueMonthly: DashboardData?.totalRevenueMonthly,
        totalCompletedBookings: DashboardData?.totalCompletedBookings,
        upcomingBookings: DashboardData?.upcomingBookings,

        requestedBookingsCount: DashboardData?.requestedBookingsCount,
        rejectedBookingsCount: DashboardData?.rejectedBookingsCount,
        acceptedBookingsCount: DashboardData?.acceptedBookingsCount,
        cancelledBookingsCount: DashboardData?.cancelledBookingsCount,
        completedBookingsCount: DashboardData?.completedBookingsCount,
        inProgressBookingsCount: DashboardData?.inProgressBookingsCount,
        inRouteBookingsCount: DashboardData?.inRouteBookingsCount,
      }));

      RevenueGraphData();
      StatusGraphData(DashboardData);
    }
  }, [DashboardData]);

  const DeletePopup = (state, id = "") => {
    setDelete((pre) => ({
      ...pre,
      open: state,
      dumpId: id,
    }));
  };

  const handleDelete = () => {
    const callBack = (response) => {
      if (response.status == "success") {
        toast.success(response.message);
        setDelete(false);
        dispatch(dashboardDetails());
      } else {
        toast.error(response.message);
      }
    };
    dispatch(deleteUser({ userId: Delete.dumpId }, callBack));
  };

  const revenueDataGraph = [
    {
      name: 1,
      revenue: 0,
      adminCommission: 0,
    },
    {
      name: 2,
      revenue: 0,
      adminCommission: 0,
    },
    {
      name: 3,
      revenue: 0,
      adminCommission: 0,
    },
    {
      name: 4,
      revenue: 0,
      adminCommission: 0,
    },
    {
      name: 5,
      revenue: 0,
      adminCommission: 0,
    },
    {
      name: 6,
      revenue: 0,
      adminCommission: 0,
    },
    {
      name: 7,
      revenue: 0,
      adminCommission: 0,
    },
  ];

  const RevenueGraphData = async () => {
    var revenueData = (await DashboardData?.weeklyRevenue) || 0;

    const revenueDataFilter = {};
    const adminCommissionDataFilter = {};
    for (var i in revenueData) {
      let date = revenueData[i]._id;
      revenueDataFilter[date] = revenueData[i]?.totalRevenue;
      adminCommissionDataFilter[date] = revenueData[i]?.adminCommission;
    }

    for (let index = 0; index < revenueDataGraph.length; index++) {
      let GraphDay = revenueDataGraph[index].name;
      if (revenueDataFilter.hasOwnProperty(GraphDay)) {
        revenueDataGraph[index].revenue = revenueDataFilter[GraphDay];
      }
      if (revenueDataFilter.hasOwnProperty(GraphDay)) {
        revenueDataGraph[index].adminCommission =
          adminCommissionDataFilter[GraphDay];
      }
    }
    const revenueDataArr = [];
    const adminCommissionDataArr = [];

    await revenueDataGraph.map((data) => {
      revenueDataArr.push(data.revenue);
    });

    await revenueDataGraph.map((data) => {
      adminCommissionDataArr.push(data.adminCommission);
    });

    SetGraphData((pre) => ({
      ...pre,
      revenue: revenueDataArr,
      adminCommission: adminCommissionDataArr,
    }));
  };

  const StatusGraphData = async (DashboardData) => {
    const statusDataArr = [];
    if (DashboardData?.requestedBookingsCount != undefined) {
      statusDataArr.push(DashboardData?.requestedBookingsCount);
      statusDataArr.push(DashboardData?.acceptedBookingsCount);
      statusDataArr.push(DashboardData?.rejectedBookingsCount);
      statusDataArr.push(DashboardData?.inRouteBookingsCount);
      statusDataArr.push(DashboardData?.inProgressBookingsCount);
      statusDataArr.push(DashboardData?.completedBookingsCount);
      statusDataArr.push(DashboardData?.cancelledBookingsCount);

      SetGraphData((pre) => ({
        ...pre,
        status: statusDataArr,
      }));
    }
  };

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="">
              <Row>
                <Col lg="3" sm="6" className="my-2">
                  <div className="bg-white px-4 py-3 card-box rounded">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="left">
                        <p className="mb-2 text-muted">Bookings</p>
                        <h5 className=" m-0 pt-2">
                          {state?.totalBookingsCount}
                        </h5>
                      </div>
                      <div className="right">
                        <div className="animated-icn position-relative rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M21 3.75V17.25C21 17.4489 20.921 17.6397 20.7803 17.7803C20.6397 17.921 20.4489 18 20.25 18C20.0511 18 19.8603 17.921 19.7197 17.7803C19.579 17.6397 19.5 17.4489 19.5 17.25V4.5H6.75C6.55109 4.5 6.36032 4.42098 6.21967 4.28033C6.07902 4.13968 6 3.94891 6 3.75C6 3.55109 6.07902 3.36032 6.21967 3.21967C6.36032 3.07902 6.55109 3 6.75 3H20.25C20.4489 3 20.6397 3.07902 20.7803 3.21967C20.921 3.36032 21 3.55109 21 3.75ZM17.25 6H3.75C3.55109 6 3.36032 6.07902 3.21967 6.21967C3.07902 6.36032 3 6.55109 3 6.75V20.25C3 20.4489 3.07902 20.6397 3.21967 20.7803C3.36032 20.921 3.55109 21 3.75 21H17.25C17.4489 21 17.6397 20.921 17.7803 20.7803C17.921 20.6397 18 20.4489 18 20.25V6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="3" sm="6" className="my-2">
                  <div className="bg-white px-4 py-3 card-box rounded">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="left">
                        <p className="mb-2 text-muted">Revenue</p>
                        <h5 className=" m-0 pt-2">
                          $ {state?.totalRevenue?.toFixed(2)}
                        </h5>
                      </div>
                      <div className="right">
                        <div className="animated-icn position-relative rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_2_2)">
                                <path
                                  d="M0.88031 0.914062V4.64794C2.97487 4.90959 4.70142 5.81822 6.34861 6.85837L5.18845 7.79883L9.95953 10.2319L8.64984 4.99219L7.43554 5.97656C6.4875 4.10109 5.43033 2.33297 4.02539 0.914062H0.88031ZM13.8823 0.914062C13.1499 2.26242 12.5132 3.63872 11.9239 5.04637L10.5087 4.74609L11.7247 10.0078L14.8681 5.67188L13.481 5.3775C15.0414 3.74873 16.6496 2.1997 18.5464 0.914062H13.8823ZM23.1401 5.313C21.3594 5.42934 19.7632 6.23536 18.2168 7.23047L17.6323 5.70563L13.8794 9.58889L19.2276 9.86719L18.6065 8.24705C20.1177 8.20327 21.6289 8.33269 23.1401 9.249V5.313V5.313ZM14.045 11.3144C13.7975 11.32 13.5664 11.4277 13.251 11.7642L12.9434 12.0908L12.624 11.7758C12.2777 11.4345 12.0045 11.3403 11.7275 11.3525C11.4506 11.3647 11.1249 11.5103 10.7607 11.8051L10.4692 12.0409L10.1924 11.789C9.77522 11.4116 9.41967 11.2997 9.07912 11.3173C8.83125 11.3302 8.57404 11.4235 8.3174 11.5868L10.2378 15.041C10.9622 15.484 12.4425 15.6507 13.4604 15.1377L15.3164 11.6997C14.9644 11.5561 14.648 11.409 14.3745 11.3525C14.2755 11.332 14.1836 11.3171 14.0947 11.3144C14.0781 11.314 14.0615 11.314 14.045 11.3144V11.3144ZM9.82762 15.8233C8.98223 16.4206 8.30344 17.4507 8.04051 18.9595C7.78575 20.4218 8.18714 21.4094 8.89748 22.0825C9.60787 22.7556 10.6741 23.1014 11.7569 23.0873C12.8397 23.0733 13.9195 22.6978 14.6455 22.0122C15.3716 21.3266 15.7822 20.3516 15.5494 18.9565C15.3086 17.5148 14.6869 16.5121 13.8998 15.9053C12.5647 16.611 10.8954 16.461 9.82762 15.8232V15.8233Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2_2">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="3" sm="6" className="my-2">
                  <div className="bg-white px-4 py-3 card-box rounded">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="left">
                        <p className="mb-2 text-muted">Customers</p>
                        <h5 className=" m-0 pt-2">{state?.totalUser}</h5>
                      </div>
                      <div className="right">
                        <div className="animated-icn position-relative rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2M7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.5 17.38 16.93 18.28C15.5294 19.396 13.7909 20.0026 12 20C10.14 20 8.43 19.36 7.07 18.28ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.57618 15.4446 3.99967 13.7467 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.5 18.36 16.83M12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM12 11C11.6022 11 11.2206 10.842 10.9393 10.5607C10.658 10.2794 10.5 9.89782 10.5 9.5C10.5 9.10218 10.658 8.72064 10.9393 8.43934C11.2206 8.15804 11.6022 8 12 8C12.3978 8 12.7794 8.15804 13.0607 8.43934C13.342 8.72064 13.5 9.10218 13.5 9.5C13.5 9.89782 13.342 10.2794 13.0607 10.5607C12.7794 10.842 12.3978 11 12 11Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="3" sm="6" className="my-2">
                  <div className="bg-white px-4 py-3 card-box rounded">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="left">
                        <p className="mb-2 text-muted">Providers</p>
                        <h5 className=" m-0 pt-2">{state?.totalProviders}</h5>
                      </div>
                      <div className="right">
                        <div className="animated-icn position-relative rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2M7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.5 17.38 16.93 18.28C15.5294 19.396 13.7909 20.0026 12 20C10.14 20 8.43 19.36 7.07 18.28ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.57618 15.4446 3.99967 13.7467 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.5 18.36 16.83M12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM12 11C11.6022 11 11.2206 10.842 10.9393 10.5607C10.658 10.2794 10.5 9.89782 10.5 9.5C10.5 9.10218 10.658 8.72064 10.9393 8.43934C11.2206 8.15804 11.6022 8 12 8C12.3978 8 12.7794 8.15804 13.0607 8.43934C13.342 8.72064 13.5 9.10218 13.5 9.5C13.5 9.89782 13.342 10.2794 13.0607 10.5607C12.7794 10.842 12.3978 11 12 11Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col lg="8" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <div className="top">
                  <h4 className="dashboard-head m-0">Weekly Revenue</h4>
                </div>
                <DashboardRevenueGraph
                  list={list}
                  revenue={graphData.revenue}
                  adminCommission={graphData.adminCommission}
                />
              </div>
            </Col>
            <Col lg="4" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <div className="top">
                  <h4 className="dashboard-head m-0">Booking Status</h4>
                </div>
                <DashboardStatusGraph
                  list={list}
                  statusCount={graphData.status}
                />
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <div className="top">
                  <h4 className="dashboard-head m-0">Latest Customers</h4>
                </div>
                <div className="table-responsive py-3">
                  <DataTable className="">
                    <DataTableHead
                      columns={columnData}
                      orderBy={"createdAt"}
                      // sort={this.handleRequestSort}
                    />
                    <DataTableBody
                      loading={loading}
                      column={columnData}
                      data={state?.latestUsers}
                      page={0}
                      rowsPerPage={state?.latestUsers?.length}
                      actionBtn={[
                        {
                          label: "View",
                          icon: "",
                          link: "/customers/profile",
                        },
                        { label: "Delete", icon: "", action: DeletePopup },
                        {
                          label: "Edit",
                          icon: "",
                          link: "/customers/edit",
                        },
                      ]}
                    />
                  </DataTable>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={Delete.open}
        onHide={() => {
          setDelete(false);
        }}
        className="deleteAdd-pop delete-pop"
        centered
      >
        <Modal.Body>
          <div className="text-center py-3">
            <div className="icn my-3">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                  fill="#f8c886"
                ></path>
                <path
                  d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                  fill="#f8c886"
                ></path>
                <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
              </svg>
            </div>
            <h2 className="pop-head m-0 pb-2">Are you Sure?</h2>
            <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3">
              <div className="pe-2 w-50">
                <Button
                  className="btn-2 w-100 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setDelete(false);
                  }}
                >
                  No Cancel!
                </Button>
              </div>
              <div className="pe-2 w-50">
                <Button
                  onClick={handleDelete}
                  className=" w-100 d-flex align-items-center justify-content-center"
                >
                  Yes, Delete it
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default DashboardIndex;
